function initialState() {
  return {
    solution: {},
    addonProducts: [],
    orderNotes: "",
    retailerOrderRef: "",
    customer: {
      fullName: "",
      email: "",
      phone: "",
      addressLine1: "",
      place: "",
      postCode: "",
      approvedByHouseOwner: "",
      carBrand: { label: "", value: "" },
      carModel: { label: "", value: "" },
      carDeliveryDate: {}
    }
  }
}

const mutations = {
  SET_SOLUTION(state, solution) {
    state.solution = solution;
  },

  SET_ORDER(state, order) {
    Object.keys(state).forEach(key => {
      state[key] = order[key]
    })
  },


  // perhaps obsolete
  SET_CUSTOMER_FIELD(state, object) {
    state.customer[object.key] = object.value;
  },

  SET_CUSTOMER(state, customer) {
    state.customer = customer;
  },

  SET_ORDER_FIELD(state, object) {
    state[object.key] = object.value;
  },

  ADD_ADDON(state, object) {
    state.addonProducts.push(object);
  },


  REMOVE_ADDON(state, id) {
    state.addonProducts = state.addonProducts.filter(obj => obj.id != id);
  },

  RESET_ORDER(state, object) {
    const s = initialState();
    Object.keys(s).forEach(key => {
      state[key] = s[key]
    })

  }
}


export default {
  state: initialState,
  mutations
}